<template>
  <div class="flex h-full min-w-0 overflow-y-hidden">
    <div class="min-w-64 h-full flex flex-col min-h-0 overflow-hidden">
      <router-link :to="{ name: ROUTE_NAMES.home }" class="pl-5 pt-8 text-sm text-gray-dark hover:text-primary shrink-0">
        ← Back to Amio
      </router-link>
      <h2 class="font-bold pl-5 pt-2 shrink-0">Admin</h2>
      <admin-list/>
    </div>

    <shadowed-wrapper class="w-full min-w-0 overflow-hidden">
      <router-view></router-view>
    </shadowed-wrapper>
  </div>
</template>

<script>
import ShadowedWrapper from '@/components/base-components/ShadowedWrapper.vue'
import AdminList, { getAdminSectionTitle } from '@/components/admin/AdminList.vue'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'AdminLayout',

  metaInfo() {
    return { title: `${this.adminSectionTitle} | Admin` }
  },

  components: { AdminList, ShadowedWrapper },

  data() {
    return { ROUTE_NAMES }
  },

  computed: {
    adminSectionTitle() {
      return getAdminSectionTitle(this.$route.name)
    }
  }
}
</script>
